import { render } from "./commandeenvoyee.vue?vue&type=template&id=ceb67f64&scoped=true"
import script from "./commandeenvoyee.vue?vue&type=script&lang=js"
export * from "./commandeenvoyee.vue?vue&type=script&lang=js"

import "./commandeenvoyee.vue?vue&type=style&index=0&id=ceb67f64&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceb67f64"]])

export default __exports__